export default [
    {
      path: '/rent/v2/customer-service-center',
      name: 'customerServiceCenter',
      component: () => import('@/pages/customerServiceCenter/customerServiceCenter'),
      meta: { title: '消息', requireAuth: true },
    },
    {
      path: '/rent/v2/customer-service-center-detail',
      name: 'customerServiceCenterDetail',
      component: () => import('@/pages/customerServiceCenter/customerServiceCenterDetail'),
      meta: { title: '问题详情', requireAuth: true },
    },
]


// WEBPACK FOOTER //
// ./src/pages/customerServiceCenter/customerCenter.js